export default {
  'templates': {
    'name': 'templates',
    'fields': {
      'title': {
        'name': 'title',
        'label': 'Title',
        'type': 'text'
      },
      'description': {
        'name': 'description',
        'label': 'Description',
        'type': 'textarea'
      },
      'originalDocumentName': {
        'name': 'originalDocumentName',
        'label': 'Original Document Name',
        'type': 'text'
      },
      'active': {
        'name': 'active',
        'label': 'Active',
        'type': 'boolean'
      },
      'appId': {
        'name': 'appId',
        'label': 'App Id',
        'type': 'text'
      },
      'createdAt': {
        'name': 'createdAt',
        'label': 'Created At',
        'type': 'text'
      },
      'updatedAt': {
        'name': 'updatedAt',
        'label': 'Updated At',
        'type': 'text'
      },
      'createdBy': {
        'name': 'createdBy',
        'label': 'Created By',
        'type': 'text'
      },
      'updatedBy': {
        'name': 'updatedBy',
        'label': 'Updated By',
        'type': 'text'
      },
      'realm': {
        'name': 'realm',
        'label': 'Realm',
        'type': 'text'
      },
      'provider': {
        'name': 'provider',
        'label': 'Provider',
        'type': 'text'
      },
      'snapToGrid': {
        'name': 'snapToGrid',
        'label': 'Snap To Grid',
        'type': 'text'
      }
    }
  },
  'pages': {
    'name': 'pages',
    'fields': {
      'pageNumber': {
        'name': 'pageNumber',
        'label': 'Page Number',
        'type': 'number'
      },
      'templateId': {
        'name': 'templateId',
        'label': 'Template Id',
        'type': 'text'
      },
      'fileName': {
        'name': 'pageName',
        'label': 'Page Name',
        'type': 'text'
      },
      'createdAt': {
        'name': 'createdAt',
        'label': 'Created At',
        'type': 'text'
      },
      'updatedAt': {
        'name': 'updatedAt',
        'label': 'Updated At',
        'type': 'text'
      },
      'createdBy': {
        'name': 'createdBy',
        'label': 'Created By',
        'type': 'text'
      },
      'updatedBy': {
        'name': 'updatedBy',
        'label': 'Updated By',
        'type': 'text'
      },
      'realm': {
        'name': 'realm',
        'label': 'Realm',
        'type': 'text'
      }
    }
  },
  'transactions': {
    'name': 'submitted-forms',
    'fields': {
      'url': {
        'name': 'formUrl',
        'label': 'Form URL',
        'type': 'url'
      },
      'ipAddress': {
        'name': 'ipAddress',
        'label': 'IP Address',
        'type': 'text'
      },
      'action':{
        'name': 'action',
        'label': 'Action',
        'type': 'text'
      },
      'rids':{
        'name': 'rids',
        'label': "Record Ids",
        'type': 'JSON'
      },
      'templateId': {
        'name': 'templateId',
        'label': 'Template Id',
        'type': 'text'
      },
      'status': {
        'name': 'status',
        'label': 'Status',
        'type': 'text'
      },
      'createdAt': {
        'name': 'createdAt',
        'label': 'Created At',
        'type': 'text'
      },
      'updatedAt': {
        'name': 'updatedAt',
        'label': 'Updated At',
        'type': 'text'
      },
      'createdBy': {
        'name': 'createdBy',
        'label': 'Created By',
        'type': 'text'
      },
      'updatedBy': {
        'name': 'updatedBy',
        'label': 'Updated By',
        'type': 'text'
      },
      'realm': {
        'name': 'realm',
        'label': 'Realm',
        'type': 'text'
      }
    }
  },
  'tokens': {
    'name': 'tokens',
    'fields': {
      'fieldId': {
        'name': 'fieldId',
        'label': 'Field Id',
        'type': 'text'
      },
      'layout': {
        'name': 'layout',
        'label': 'Layout',
        'type': 'textarea'
      },
      'format': {
        'name': 'format',
        'label': 'Format',
        'type': 'text'
      },
      'content': {
        'name': 'content',
        'label': 'Content',
        'type': 'textarea'
      },
      'pageId': {
        'name': 'pageId',
        'label': 'Page Id',
        'type': 'text'
      },
      'templateId': {
        'name': 'templateId',
        'label': 'Template Id',
        'type': 'text'
      },
      'referenceId': {
        'name': 'referenceId',
        'label': 'Reference Id',
        'type': 'text'
      },
      'type': {
        'name': 'type',
        'label': 'Type',
        'type': 'text'
      },
      'disabled': {
        'name': 'disabled',
        'label': 'Disabled',
        'type': 'boolean'
      },
      'required': {
        'name': 'required',
        'label': 'Required',
        'type': 'boolean'
      },
      'createdAt': {
        'name': 'createdAt',
        'label': 'Created At',
        'type': 'text'
      },
      'updatedAt': {
        'name': 'updatedAt',
        'label': 'Updated At',
        'type': 'text'
      },
      'createdBy': {
        'name': 'createdBy',
        'label': 'Created By',
        'type': 'text'
      },
      'updatedBy': {
        'name': 'updatedBy',
        'label': 'Updated By',
        'type': 'text'
      },
      'realm': {
        'name': 'realm',
        'label': 'Realm',
        'type': 'text'
      }
    }
  },
  'references': {
    'name': 'references',
    'fields': {
      'tableId': {
        'name': 'tableId',
        'label': 'Table Id',
        'type': 'text'
      },
      'name': {
        'name': 'name',
        'label': 'Name',
        'type': 'text'
      },
      'templateId': {
        'name': 'templateId',
        'label': 'Template Id',
        'type': 'text'
      },
      'createdAt': {
        'name': 'createdAt',
        'label': 'Created At',
        'type': 'text'
      },
      'updatedAt': {
        'name': 'updatedAt',
        'label': 'Updated At',
        'type': 'text'
      },
      'uploadFID': {
        'name': 'uploadFID',
        'label': 'uploadFID',
        'type': 'text'
      },
      'createdBy': {
        'name': 'createdBy',
        'label': 'Created By',
        'type': 'text'
      },
      'updatedBy': {
        'name': 'updatedBy',
        'label': 'Updated By',
        'type': 'text'
      },
      'realm': {
        'name': 'realm',
        'label': 'Realm',
        'type': 'text'
      }
    }
  },
  'app-tokens': {
    'name': 'app-tokens',
    'fields': {
      'appToken': {
        'name': 'appToken',
        'label': 'App Token',
        'type': 'text'
      },
      'createdBy': {
        'name': 'createdBy',
        'label': 'Created By',
        'type': 'text'
      },
      'updatedBy': {
        'name': 'updatedBy',
        'label': 'Updated By',
        'type': 'text'
      },
      'realm': {
        'name': 'realm',
        'label': 'Realm',
        'type': 'text'
      },
      'updatedAt': {
        'name': 'updatedAt',
        'label': 'Updated At',
        'type': 'date'
      },
      'createdAt': {
        'name': 'createdAt',
        'label': 'Created At',
        'type': 'date'
      },
    }
  },
  'profiles': {
    'name': 'profiles',
    'fields': {
      'firstName': {
        'name': 'firstName',
        'label': 'First Name',
        'type': 'text'
      },
      'lastName': {
        'name': 'lastName',
        'label': 'Last Name',
        'type': 'text'
      },
      'email': {
        'name': 'email',
        'label': 'QuickBase Email',
        'type': 'text'
      },
      'realm': {
        'name': 'realm',
        'label': 'QuickBase Realm',
        'type': 'text'
      },
      'company': {
        'name': 'company',
        'label': 'Company',
        'type': 'text'
      },
      'phone': {
        'name': 'phone',
        'label': 'Phone Number',
        'type': 'text'
      },
      'createdAt': {
        'name': 'createdAt',
        'label': 'Created At',
        'type': 'text'
      },
      'updatedAt': {
        'name': 'updatedAt',
        'label': 'Updated At',
        'type': 'text'
      },
      'createdBy': {
        'name': 'createdBy',
        'label': 'Created By',
        'type': 'text'
      },
      'updatedBy': {
        'name': 'updatedBy',
        'label': 'Updated By',
        'type': 'text'
      },
      'comments': {
        'name': 'comments',
        'label': 'Comments',
        'type': 'text'
      },
    }
  },
  'relations': {
    'name': 'relations',
    'fields': {
      'parentId': {
        'name': 'parentId',
        'label': 'Parent Id',
        'type': 'text'
      },
      'childId': {
        'name': 'childId',
        'label': 'Child Id',
        'type': 'text'
      },
      'templateId': {
        'name': 'templateId',
        'label': 'Template Id',
        'type': 'text'
      },
      'fieldId': {
        'name': 'fieldId',
        'label': 'Field Id',
        'type': 'text'
      },
      'createdBy': {
        'name': 'createdBy',
        'label': 'Created By',
        'type': 'text'
      },
      'updatedBy': {
        'name': 'updatedBy',
        'label': 'Updated By',
        'type': 'text'
      },
      'realm': {
        'name': 'realm',
        'label': 'Realm',
        'type': 'text'
      },
      'updatedAt': {
        'name': 'updatedAt',
        'label': 'Updated At',
        'type': 'date'
      },
      'createdAt': {
        'name': 'createdAt',
        'label': 'Created At',
        'type': 'date'
      },
    }
  },
  'behaviors': {
    'name': 'behaviors',
    'fields': {
      'childId': {
        'name': 'childId',
        'label': 'Child Id',
        'type': 'text'
      },
      'behavior': {
        'name': 'behavior',
        'label': 'Behavior',
        'type': 'text'
      },
      'logic': {
        'name': 'logic',
        'label': 'Logic Operation',
        'type': 'text'
      },
      'templateId': {
        'name': 'templateId',
        'label': 'Template Id',
        'type': 'text'
      },
      'createdBy': {
        'name': 'createdBy',
        'label': 'Created By',
        'type': 'text'
      },
      'updatedBy': {
        'name': 'updatedBy',
        'label': 'Updated By',
        'type': 'text'
      },
      'realm': {
        'name': 'realm',
        'label': 'Realm',
        'type': 'text'
      },
      'updatedAt': {
        'name': 'updatedAt',
        'label': 'Updated At',
        'type': 'date'
      },
      'createdAt': {
        'name': 'createdAt',
        'label': 'Created At',
        'type': 'date'
      },
    }
  },
  'conditions': {
    'name': 'conditions',
    'fields': {
      'parentId': {
        'name': 'parentId',
        'label': 'Parent Id',
        'type': 'text'
      },
      'childId': {
        'name': 'childId',
        'label': 'Child Id',
        'type': 'text'
      },
      'evaluation': {
        'name': 'evaluation',
        'label': 'Evaluation',
        'type': 'text'
      },
      'operation': {
        'name': 'operation',
        'label': 'Operation',
        'type': 'text'
      },
      'templateId': {
        'name': 'templateId',
        'label': 'Template Id',
        'type': 'text'
      },
      'behaviorId': {
        'name': 'behaviorId',
        'label': 'Behavior Id',
        'type': 'text'
      },
      'createdBy': {
        'name': 'createdBy',
        'label': 'Created By',
        'type': 'text'
      },
      'updatedBy': {
        'name': 'updatedBy',
        'label': 'Updated By',
        'type': 'text'
      },
      'realm': {
        'name': 'realm',
        'label': 'Realm',
        'type': 'text'
      },
      'updatedAt': {
        'name': 'updatedAt',
        'label': 'Updated At',
        'type': 'date'
      },
      'createdAt': {
        'name': 'createdAt',
        'label': 'Created At',
        'type': 'date'
      },
    }
  }
}
